import { t } from '@lingui/macro';
import { Submitted, Reviewed } from '../../helpers/icon-dictionary';

const tt = v => new StringProxy(v);

function StringProxy(value) { this.value = value; }
StringProxy.prototype.toString = function proxyToString() {
  return window.i18n._(this.value);
};

export const UNASSIGNED = 'UNASSIGNED'; // 0
export const UNATTEMPTED = 'UNATTEMPTED'; // 1
export const ASSIGN_SELECTION = 'ASSIGN_SELECTION'; // 2
export const PARTIAL = 'PARTIAL'; // 3
export const CORRECT = 'CORRECT'; // 4
export const ASSIGNED = 'ASSIGNED'; // 5
export const UNASSIGN_SELECTION = 'UNASSIGN_SELECTION'; // 6
export const INCORRECT = 'INCORRECT'; // 7
export const UNAVAILABLE = 'UNAVAILABLE'; // 8
export const SCHEDULED_ASSIGN = 'SCHEDULED_ASSIGN'; // 9

export const statusCodes = {
  [UNASSIGNED]: 0,
  [UNATTEMPTED]: 1,
  [ASSIGN_SELECTION]: 2,
  [PARTIAL]: 3,
  [CORRECT]: 4,
  [ASSIGNED]: 5,
  [UNASSIGN_SELECTION]: 6,
  [INCORRECT]: 7,
  [UNAVAILABLE]: 8,
  [SCHEDULED_ASSIGN]: 9
};

export const statusLabels = {
  [ASSIGNED]: tt(t`Assigned`),
  [UNASSIGNED]: tt(t`Unassigned`),
  [UNATTEMPTED]: tt(t`Not Attempted`),
  [CORRECT]: tt(t`Correct`),
  [INCORRECT]: tt(t`Incorrect`),
  [UNAVAILABLE]: tt(t`Currently Unavailable`),
  [SCHEDULED_ASSIGN]: tt(t`Scheduled`)
};

export const statusMarks = {
  [ASSIGNED]: '',
  [UNASSIGNED]: '-',
  [UNATTEMPTED]: '0',
  [CORRECT]: '1',
  [INCORRECT]: '0',
  [UNAVAILABLE]: '-',
  [SCHEDULED_ASSIGN]: '-'
};

const getStatus = (code) => {
  switch (code) {
    case 0:
      return UNASSIGNED;
    case 1:
      return UNATTEMPTED;
    case 2:
      return ASSIGN_SELECTION;
    case 3:
      return PARTIAL;
    case 4:
      return CORRECT;
    case 5:
      return ASSIGNED;
    case 6:
      return UNASSIGN_SELECTION;
    case 7:
      return INCORRECT;
    case 8:
      return UNAVAILABLE;
    case 9:
      return SCHEDULED_ASSIGN;
    default:
      break;
  }
  return code;
};

const getConversationIcon = (teacher) => {
  switch (teacher) {
    case 1:
    case 3:
      return Submitted;
    case 2:
      return Reviewed;
    default:
      break;
  }

  return '';
};

export {
  getStatus,
  getConversationIcon
};
